import React from 'react';

export default function Input({
	type = 'text',
	name,
	label,
	placeholder,
	value,
	onChange,
	error,
	required,
	disabled,
	className = ''
}) {
	return (
		<div className={`w-full ${className}`}>
			{label && (
				<label htmlFor={name} className="block text-sm font-medium text-gray-700 mb-1">
					{label} {required ? <span className="text-red-600">*</span> : null}
				</label>
			)}
			<input
				id={name}
				name={name}
				type={type}
				placeholder={placeholder}
				value={value}
				onChange={onChange}
				disabled={disabled}
				className={`block w-full rounded-md border ${
					error ? 'border-red-500' : 'border-gray-300'
				} px-3 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500`}
			/>
			{error && <p className="mt-1 text-xs text-red-600">{error}</p>}
		</div>
	);
}


